import React from 'react';
import landing from "../Styles/LandingPage.module.css";
import {Link} from "react-router-dom";

const TopMenu = ({isActiveHome = false, product= false, about = false, contact = false}) => {
    return (
        <ul className={landing.menu}>
            <div style={{
                position: "absolute",
                marginLeft:"-1000px",
                marginTop:"-2px",
                fontSize:"2rem"
            }}
            >
                Dialogue System X
            </div>
            <li>
                <Link
                    style={{
                        textDecoration: "none",
                        color: isActiveHome ? "deeppink" : "white",
                    }}
                    to={{pathname: "/"}}>Home
                </Link>

            </li>
            <li>
                <Link
                    style={{
                        textDecoration: "none",
                        color: product ? "deeppink" : "white",
                    }}
                    to={{pathname: "/product"}}>Product
                </Link>

            </li>
            <li>
                <Link
                    style={{
                        textDecoration: "none",
                        color: about ? "deeppink" : "white",
                    }}
                    to={{pathname: "/about"}}>About
                </Link>

            </li>
            <li>
                <Link
                    style={{
                        textDecoration: "none",
                        color: contact ? "deeppink" : "white",
                    }}
                    to={{pathname: "/contact"}}> Contact
                </Link>

            </li>

            <li>


                <a style={{
                    textDecoration:"none",
                    color:"white"
                }}
                   target="_blank"
                    href="https://forms.gle/qr9LBVmDvjTgwdmj8">

                    Feedback
                </a>

            </li>


            <Link
                className={landing.appButton}

                to={{pathname: "/app"}}>App
            </Link>

        </ul>
    );
};

export default TopMenu;